import { NgModule } from '@angular/core';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './notifications-pop.constant';

const en = { };

export type NotificationsPopTranslations = typeof en;

@NgModule()
export class NotificationsPopTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
